import { graphql } from "@/graphql/codegen"

import "./invoice.fragment"

graphql(`
  query GetInvoiceList($input: InvoiceListInput!) {
    invoice {
      list(input: $input) {
        __typename
        ... on InvoiceListSuccess {
          invoices {
            ...InvoiceListExpandedRowFields
          }
          pageInfo {
            offset
            limit
            total
          }
        }
        ... on InvoiceListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
